// extracted by mini-css-extract-plugin
module.exports = {"card":"x1l4MLfpiDrtICi1BuhA","description":"lCfUFLt6OF5bJr7CIxSu"};